import { render, staticRenderFns } from "./table-controls.vue?vue&type=template&id=51d1e1d8&scoped=true&"
import script from "./table-controls.vue?vue&type=script&lang=js&"
export * from "./table-controls.vue?vue&type=script&lang=js&"
import style0 from "./table-controls.vue?vue&type=style&index=0&id=51d1e1d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d1e1d8",
  null
  
)

export default component.exports